import { render, staticRenderFns } from "./OnlineAppointmentsSettingIndex.vue?vue&type=template&id=06986cc0&scoped=true"
import script from "./OnlineAppointmentsSettingIndex.vue?vue&type=script&lang=js"
export * from "./OnlineAppointmentsSettingIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06986cc0",
  null
  
)

export default component.exports